<script setup>
import {computed, ref, watch} from "vue";

const props = defineProps({
    template: Object
})

const loadedFonts = ref([
    'Inter'
])

watch(() => props.template.font, (now) => {
    if(!loadedFonts.value.includes(now) && props.template.font_url) {
        const link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('type', 'text/css');
        link.setAttribute('href', props.template.font_url);
        document.head.appendChild(link);
        loadedFonts.value.push(now);
    }
}, { immediate: true })

const rootEmailStyles = computed(() => {
    return {
        fontFamily: props.template.font,
        backgroundColor: '#' + props.template.background_color,
        color: '#' + props.template.text_color
    }
})
</script>

<template>
    <div :style="rootEmailStyles" class="flex grow flex-col justify-center items-center">
        <div id="logo-section" class="py-10 flex justify-center">
            <img :src="template.logo_image" width="200"/>
        </div>
        <div id="body-section" class="p-4 bg-white rounded-lg border mx-3 2xl:w-[700px]">
            <p><slot name="text-1"></slot></p>
            <p><slot name="text-2"></slot></p>
        </div>
        <div id="footer-section" class="m-6 text-center">
            <p>{{template.footer}}</p>
            <small class="opacity-50">{{ $t('forms.email_not_promo') }}</small>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
